var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcOpenRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.858 12.514a1 1 0 0 0 0-1.029l-6-10a1 1 0 1 0-1.715 1.03L13.833 12l-5.69 9.485a1 1 0 1 0 1.715 1.03z",
  clipRule: "evenodd"
})));
export default SvgIcOpenRight;